import { Card, InfoRow } from './BmsCardPrimitives'

const FlagsAndFaultsCard = ({ bms, className = '' }) => (
  <Card className={className}>
    <InfoRow label="Balancing flags" value={bms.balancingFlags} />
    <InfoRow label="PCHG fail" value={bms.pchgFail} />
    <InfoRow label="Extra fault" value={bms.extraFault} />
  </Card>
)

export default FlagsAndFaultsCard
